import type { SVGProps } from "react";

export function IconBlueClock(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle
        cx="12"
        cy="12"
        r="10"
        fill="#5486FA"
        stroke="#5486FA"
        strokeWidth="1.5"
      />
      <path
        d="M12 6.5V12H16"
        stroke="#0B0D17"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
    </svg>
  );
}
